import {
    RAZONABILIDAD_PRICE,
    RAZONABILIDAD_PRICE_SUCCESS,
    RAZONABILIDAD_PRICE_ERROR,
    RAZONABILIDAD_PRICE_MODAL_SET,
    RAZONABILIDAD_PRICE_SEARCH_SET,
    RAZONABILIDAD_PRICE_SEARCH_CHANGE,
    RAZONABILIDAD_PRICE_DATA_SET,
    RAZONABILIDAD_PRICE_DATA_CHANGE,
    RAZONABILIDAD_PRICE_DATA_TABLE,
    ARTICLE_YEAR_RAZONABILIDAD,
    ARTICLE_YEAR_RAZONABILIDAD_SUCCESS,
    ARTICLE_YEAR_RAZONABILIDAD_ERROR,
    SOURCE_RAZONABILIDAD,
    SOURCE_RAZONABILIDAD_SUCCESS,
    SOURCE_RAZONABILIDAD_ERROR
} from '../actions';

const INIT_STATE = {
    loading: true,
    detail_data: {
        data: [],
        loading: true,
        modal:false
    },
    article_year_razonabilidad: {
        data: [],
        loading: true,
        modal: false
    },
    source_razonabilidad: {
        data: [],
        loading: true,
        modal: false
    },
    error: false,
    array_data: {
        modal: false,
        init: true,
        data: {
            idcode22: '',
            quantity: 0,
            pricebid: 0.0
        },
        value: {
            idcode22: '',
            quantity: 0,
            pricebid: 0.0
        }
    },
    table_data: {
        modal: false,
        loading:true,
        init: true,
        data: {
            idcode22: '',
            quantity: 0,
            pricebid: 0.0
        },
        value: {
            idcode22: '',
            quantity: 0,
            pricebid: 0.0
        }
    },
    search: {
        modal: false,
        init: true,
        data: {
            idcode22: '',
            idcode22_country: '',
            quantity: 0,
            pricebid: 0.0,
            year: '',
            source:''
        },
        value: {
            idcode22: '',
            idode22_country: '',
            quantity: 0,
            pricebid: 0.0,
            year: '',
            source:''
        }
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case RAZONABILIDAD_PRICE:
            return {
                ...state,
                detail_data: {
                    loading: true,
                    ...state.detail_data
                }
            }
        case RAZONABILIDAD_PRICE_SUCCESS:
            return {
                ...state,
                loading: false,
                detail_data: {
                    loading: false,
                    ...state.detail_data,
                    ...action.payload
                }
            }
        case RAZONABILIDAD_PRICE_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        case RAZONABILIDAD_PRICE_MODAL_SET:
            return {
                ...state,
                detail_data: {
                    ...state.detail_data,
                    modal: action.payload
                }
            }

        case RAZONABILIDAD_PRICE_SEARCH_SET:
            return {
                ...state,
                search: {
                    ...state.search,
                    init: false,
                    data: action.payload,
                }
            }

        case RAZONABILIDAD_PRICE_SEARCH_CHANGE:
            return {
                ...state,
                search: {
                    ...state.search,
                    init: false,
                    value: action.payload,
                }
            }

        case RAZONABILIDAD_PRICE_DATA_SET:
            return {
                ...state,
                array_data: {
                    ...state.array_data,
                    data: action.payload,
                }
            }

        case RAZONABILIDAD_PRICE_DATA_CHANGE:
            return {
                ...state,
                array_data: {
                    ...state.array_data,
                    value: action.payload,
                }
            }

        case RAZONABILIDAD_PRICE_DATA_TABLE:
            return {
                ...state,
                loading: false,
                table_data: {
                    ...state.table_data,
                    data: action.payload,
                }
            }

        case ARTICLE_YEAR_RAZONABILIDAD:
            return {
                ...state,
                init: false,
                article_year_razonabilidad: {
                    ...state.article_year_razonabilidad,
                    loading: true,
                    message: ''
                }
            }
        case ARTICLE_YEAR_RAZONABILIDAD_SUCCESS:
            return {
                ...state,
                article_year_razonabilidad: {
                    ...state.article_year_razonabilidad,
                    loading: false,
                    data: action.payload,
                    message: ''
                }
            }
        case ARTICLE_YEAR_RAZONABILIDAD_ERROR:
            return {
                ...state,
                article_year_razonabilidad: {
                    ...state.article_year_razonabilidad,
                    loading: false,
                    message: 'No se encotraron datos'
                }
            }
        case SOURCE_RAZONABILIDAD:
            return {
                ...state,
                init: false,
                source_razonabilidad: {
                    ...state.source_razonabilidad,
                    loading: true,
                    message: ''
                }
            }
        case SOURCE_RAZONABILIDAD_SUCCESS:
            return {
                ...state,
                source_razonabilidad: {
                    ...state.source_razonabilidad,
                    loading: false,
                    data: action.payload,
                    message: ''
                }
            }
        case SOURCE_RAZONABILIDAD_ERROR:
            return {
                ...state,
                source_razonabilidad: {
                    ...state.source_razonabilidad,
                    loading: false,
                    message: 'No se encotraron datos'
                }
            }
        
        default:
            return { ...state };
    }
};